/*
  You can use events, triggered when tab is changed.
  Events are triggered on linksContext element.

  Examples:
  $(".entity-tabs").on('entity-tabs:before-tab-switch', function(event, container, link, id){
    alert('New tab id: ' + id);
  });

  $("#issue-detail").find(".entity-tabs").on('entity-tabs:before-tab-switch', function(event, container, link, id){
  });

  $(EntityTabs.linksContext).on('entity-tabs:before-tab-switch', function(event, container, link, id){
  });
*/

window.EntityTabs = {
  linksContext: ".entity-tabs",
  panelContext: ".entity-tabs-content",
  dialog_head: ".ui-dialog-title",

  init: function (tabsContext) {

    if (this.linksInModalHead()) {
      var $linksContainer = $(this.dialog_head).find(this.linksContext);
    } else {
      $linksContainer = $('#' + tabsContext).find(this.linksContext);
    }

    $linksContainer.data('tabs-context', tabsContext);

    if (this.restoresLastTab($linksContainer) && this.lastTab($linksContainer)) {
      var $link = $linksContainer.find('a[data-tab-id="' + this.lastTab($linksContainer) + '"]');

      // Tab could not exist
      if ($link.length) {
        $link.click();
        this.refreshTabsButtons();
        return;
      }
    }

    // Fallback to first tab
    $linksContainer.find("a").first().click();
    this.refreshTabsButtons();
  },

  refreshTabsButtons: function () {
    if (typeof window.displayTabsButtons === "function") {
      window.displayTabsButtons();
    }
  },

  linksInModalHead: function () {
    // return $(this.linksContext).parent().is($(this.dialog_head));
    return false;
  },

  linksContainer: function (link) {
    return link.closest(this.linksContext);
  },

  panelContainer: function (link) {
    if (this.linksInModalHead()) {
      return $('#' + this.tabsContext(this.linksContainer(link))).find(this.panelContext);
    } else {
      return link.closest(this.linksContext).parent().find(this.panelContext);
    }
  },

  tabsContext: function ($linksContainer) {
    return $linksContainer.data('tabs-context');
  },

  lastTab: function ($linksContainer) {
    if (typeof(Storage) !== "undefined") {
      return localStorage.getItem(this.tabsContext($linksContainer) + "-tab");
    }
  },

  restoresLastTab: function ($linksContainer) {
    return $linksContainer.data("restore-last-tab") !== false;
  },

  saveTab: function (value, $linksContainer) {
    if (typeof(Storage) !== "undefined") {
      localStorage.setItem(this.tabsContext($linksContainer) + "-tab", value);
    }
  },

  // Show full journal history
  showHistory: function (link) {
    this.showTab(link, ".tab-history-content");
    var journals = $('.journal');
    for (var i = 0; i < journals.length; i++) {
      var that = $(journals[i]);
      if (that.hasClass('has-details')) {
        if (that.hasClass('has-notes')) {
          that.find('.details').removeClass('hidden');
          that.find('.expander').removeClass('hidden');
        }
        else {
          that.removeClass('hidden');
        }
      }
    }
  },

  // Only journal comments
  showComments: function (link) {
    this.showTab(link, ".tab-history-content");
    var journals = $('.journal');
    for (var i = 0; i < journals.length; i++) {
      var that = $(journals[i]);
      if (that.hasClass('has-details')) {
        if (that.hasClass('has-notes')) {
          that.find('.details').addClass('hidden');
          that.find('.expander').addClass('hidden');
        }
        else {
          that.addClass('hidden');
        }
      }
    }
  },

  // Load remote html first
  showAjaxTab: function (link, ajaxUrl) {
    var $link = $(link);
    var $panelContainer = this.panelContainer($link);
    var $content = $panelContainer.find("." + $link.data('tab-id') + "-content");

    this.showTab(link);

    if (!$content.data("loaded")) {
      this.loadTabContent($content, ajaxUrl);
    }
  },

  showAjaxHistory: async function (link, ajaxUrl) {
    var $link = $(link);
    var $panelContainer = this.panelContainer($link);
    var $content = $panelContainer.find("." + $link.data('tab-id') + "-content");

    this.showHistory(link);

    if (!$content.data("loaded")) {
      // Reactions require loaded tab content.
      if (!(await this.loadTabContent($content, ajaxUrl))) return;
    }

    window.EasyVue.createEntityJournalsReactions({
      ...$content.find(":first-child").data(),
      initialLoad: true,
    });
  },

  /**
   * Journal tab with its own content panel (issue comments / history): loads the journals
   * on first show and scrolls to a `#note-<id>` deep link. The loaded HTML carries the
   * per-journal reaction scripts, so no bulk reactions load is needed here.
   */
  showAjaxJournals: async function (link, ajaxUrl) {
    var $link = $(link);
    var $panelContainer = this.panelContainer($link);
    var $content = $panelContainer.find("." + $link.data("tab-id") + "-content");

    this.showTab(link);

    if ($content.data("loaded")) return;
    if (!(await this.loadTabContent($content, ajaxUrl))) return;

    this.scrollToHashedJournal($content);
  },

  // The journal anchors (`<a name="note-<id>">`) arrive after page load, so the browser could not scroll to them.
  scrollToHashedJournal: function ($content) {
    var match = /^#note-(\d+)$/.exec(window.location.hash);
    if (!match) return;

    var anchor = $content.find('a[name="note-' + match[1] + '"]')[0];
    if (anchor) anchor.scrollIntoView();
  },

  /**
   * Catch non-Error jqXHR rejections here; click handlers leave them unhandled.
   * Failed tabs remain unloaded so the next click retries.
   *
   * @return {Promise<boolean>} true when the content rendered
   */
  loadTabContent: async function ($content, ajaxUrl) {
    var html;

    try {
      html = await $.ajax(ajaxUrl);
    } catch (jqXhr) {
      // Rethrow non-request errors.
      if (!jqXhr || typeof jqXhr.status !== "number") throw jqXhr;
      this._reportTabLoadFailure(ajaxUrl, jqXhr);
      return false;
    }

    $content.html(html);
    $content.data("loaded", "true");
    this.resetPosition($content);
    $content.trigger("easy_entitytab_new_dom");
    $content.trigger("erui_new_dom");

    return true;
  },

  // Skip Bugsnag reporting for no HTTP response (0) or authentication failures (401).
  _silentTabLoadStatuses: [0, 401],

  _reportTabLoadFailure: function (ajaxUrl, jqXhr) {
    if (this._silentTabLoadStatuses.indexOf(jqXhr.status) !== -1) return;
    if (typeof window.Bugsnag === "undefined") return;

    // Keep the error message stable; put request details in metadata.
    window.Bugsnag.notify(new Error("Entity tab content failed to load"), function (event) {
      event.addMetadata("request", {
        url: ajaxUrl,
        status: jqXhr.status,
        statusText: jqXhr.statusText,
      });
    });
  },

  showTab: function (link, id) {
    var $link = $(link);

    if (typeof(id) === "undefined") {
      id = "." + $link.data('tab-id') + "-content";
    }

    var $linksContainer = this.linksContainer($link);
    $linksContainer.trigger('entity-tabs:before-tab-switch', [$linksContainer, link, id]);

    var $panelContainer = this.panelContainer($link);

    $linksContainer.find("a").removeClass("selected");
    $panelContainer.children().addClass("hidden");

    $(link).addClass("selected");
    $panelContainer.find(id).removeClass("hidden");

    this.saveTab($link.data("tab-id"), $linksContainer);
    this._sendTabUTMTracking($link, $linksContainer);
    $linksContainer.trigger("entity-tabs:after-tab-switch", [$linksContainer, link, id]);

    if (typeof(EASY.utils.initGalereya) === "function") {
      EASY.utils.initGalereya($('.thumbnails:visible'));
    }
    this.resetPosition($panelContainer);
  },

  resetPosition: function ($dialogPart) {
    var $dialog = $dialogPart.closest(".ui-dialog-content");
    if ($dialog.length !== 0) {
      //$dialogPart.closest(".ui-dialog-content").dialog('widget').position({my: "center", at: "center", of: window});
    }
  },

  _sendTabUTMTracking: function ($link, $linksContainer) {
    const currentEvent = window.event;
    if (!(currentEvent instanceof PointerEvent)) return;

    if (typeof window.EASY?.utils?.sendUTMTrackingData !== "function") return;

    const utmParams = this._getUTMParams($link, $linksContainer);
    if (utmParams) {
      window.EASY.utils.sendUTMTrackingData(utmParams);
    }
  },

  _getUTMParams: function ($link, $linksContainer) {
    const utmCampaign = this.tabsContext($linksContainer).replace("-", "_");
    const utmContent = "tabs";
    const tabId = $link.data("tab-id");
    let utmTerm;

    if (tabId) {
      utmTerm = String(tabId).replace(/^tab-/, "");
    }

    if (!utmCampaign || !utmContent || !utmTerm) return;

    return { utmCampaign, utmContent, utmTerm };
  },
};
